import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { getAspectsAttributes } from '../../utils/dataAttributes.js';
import { style } from '../../utils/style.js';
import { Text } from '../Text/Text.js';
import { ICON_SIZE } from './iconSize.js';
import { logoTitleSizeStyle } from './logoTitleSizeStyle.js';
import { renderImage } from './renderImage.js';
const TEXT_COLOR = {
    'bg-white': 'text-primary-text',
    transparent: 'text-white',
};
export const Logo = JSX(({ className, href = '/', logo, children, targetBlank, bgColor = 'bg-white', showTitle = true, data, }) => (_jsxs("a", { className: style('inline-flex items-center font-sans no-underline', className), href: logo?.href ?? href, target: targetBlank ? '_blank' : '_self', "aria-label": logo?.title ?? 'Россельхозбанк', ...getAspectsAttributes(data), children: [renderImage(bgColor, logo?.image, ICON_SIZE), showTitle
            ? children ?? (_jsx("div", { className: "ml-s", children: _jsx(Text, { font: "font-medium", color: TEXT_COLOR[bgColor], size: logoTitleSizeStyle, children: logo?.title ?? 'Россельхозбанк' }) }))
            : null] })));
//# sourceMappingURL=Logo.js.map